import { render } from "./Whatsapp.vue?vue&type=template&id=4cb3d6ba&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=4cb3d6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb3d6ba"]])

export default __exports__